import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../Config/axiosInstance';
import './AddBudgetStructure.css';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

function AddBudgetStructure() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    offer_code: '',
    project_code: '',
    cost_element_id: '',
    cost_element_description: '',
  });

  const animatedComponents = makeAnimated();

  const [offerCodes, setOfferCodes] = useState([]);
  const [projectCodes, setProjectCodes] = useState([]);
  const [allElementCost, setAllElementCost] = useState([]);
  const [existingElementCost, setExistingElementCost] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [isDuplicate, setIsDuplicate] = useState(false);

  useEffect(() => {
    axiosInstance.get('/offer-codes/')
      .then(response => {
        const formatted = response.data.map(of => ({
          value: of.id,
          label: `${of.offer_code} - ${of.description}`,
        }));
        setOfferCodes(formatted);
      })
      .catch(error => console.error("Eroare la coduri ofertă:", error));

    axiosInstance.get('/project-codes/')
      .then(response => {
        const formatted = response.data.map(pc => ({
          value: pc.id,
          label: `${pc.code} - ${pc.description}`,
        }));
        setProjectCodes(formatted);
      })
      .catch(error => console.error("Eroare la coduri proiect:", error));

    axiosInstance.get('/budget-structure/')
      .then(response => {
        setAllElementCost(response.data);
      })
      .catch(error => console.error("Eroare la element cost:", error));
  }, []);

  // Actualizare element cost în funcție de offer_code selectat
  useEffect(() => {
    if (formData.offer_code) {
      const filtered = allElementCost
        .filter(d =>
          d.offer_code_details.id === formData.offer_code &&
          (
            !formData.project_code ||
            d.project_code_details?.id === formData.project_code
          )
        )
        .map(d => d.cost_element_id);

      setExistingElementCost(filtered);
    } else {
      setExistingElementCost([]);
    }
  }, [formData.offer_code, formData.project_code, allElementCost]);


  // Validare dacă cost_element_id există deja pentru acel offer_code
  useEffect(() => {
    if (
      formData.cost_element_id &&
      existingElementCost.includes(formData.cost_element_id)
    ) {
      setErrorMessage('Cost id already exists for this offer code.');
      setIsDuplicate(true);
    } else {
      setErrorMessage('');
      setIsDuplicate(false);
    }
  }, [formData.cost_element_id, existingElementCost]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post('/budget-structure/', formData);
      navigate('/project-budget/budget-structure');
    } catch (error) {
      console.error('Eroare la salvarea datelor:', error);
    }
  };

  const handleUndo = () => {
    navigate(-1);
  };

  return (
    <div className='add-budget-page'>
      <div className="add-container">
        <div className="header">
          <IconButton onClick={handleUndo}>
            <ArrowBackIcon className="back-arrow" />
          </IconButton>
          <h2 className="add-title">Add budget structure</h2>
        </div>
      </div>

      <hr className="title-separator" />

      <div className="add-container">
        <form onSubmit={handleSave} className="add-form">

          {/* Offer Code */}
          <div className="form-group">
            <label htmlFor="offer_code" className="label">
              Offer Code <span style={{ color: 'red' }}>*</span>
            </label>
            <Select
              id="offer_code"
              name="offer_code"
              classNamePrefix="react-select"
              options={offerCodes}
              required
              value={offerCodes.find(c => c.value === formData.offer_code) || null}
              onChange={selectedOption =>
                setFormData({
                  ...formData,
                  offer_code: selectedOption ? selectedOption.value : '',
                })
              }
              components={animatedComponents}
              isClearable
              styles={{ control: (provided) => ({ ...provided, borderRadius: "8px" }) }}
            />
          </div>

          {/* Project Code */}
          <div className="form-group">
            <label htmlFor="project_code" className="label">
              Project Code
            </label>
            <Select
              id="project_code"
              name="project_code"
              classNamePrefix="react-select"
              options={projectCodes}
              value={projectCodes.find(c => c.value === formData.project_code) || null}
              onChange={selectedOption =>
                setFormData({
                  ...formData,
                  project_code: selectedOption ? selectedOption.value : '',
                })
              }
              components={animatedComponents}
              isClearable
              styles={{ control: (provided) => ({ ...provided, borderRadius: "8px" }) }}
            />
          </div>

          {/* Cost ID */}
          <div className="form-group">
            <label htmlFor="cost_element_id" className="label">
              Cost ID <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              id="cost_element_id"
              name="cost_element_id"
              value={formData.cost_element_id}
              onChange={handleChange}
              className="input"
              required
            />
            {errorMessage && <div className="error-message">{errorMessage}</div>}
          </div>

          {/* Cost Description */}
          <div className="form-group">
            <label htmlFor="cost_element_description" className="label">
              Cost description <span style={{ color: 'red' }}>*</span>
            </label>
            <textarea
              id="cost_element_description"
              name="cost_element_description"
              value={formData.cost_element_description}
              onChange={handleChange}
              className="textarea"
              required
            />
          </div>

          {/* Buttons */}
          <div className="form-group-row">
            <div className="button-group-inline">
              <button type="button" className="button discard" onClick={handleUndo}>
                Discard
              </button>
              <button type="submit" className="button save" disabled={isDuplicate}>
                Save
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  );
}

export default AddBudgetStructure;
